<template>
    <v-dialog v-model="dialog" max-width="500px" persistent>
      <v-card light v-if="dialog">
            <v-alert color="error" icon="warning" v-if="error" value="true">
                {{ error }}
            </v-alert>
        <v-card-title class="headline grey--text">
            Agregar juego
        </v-card-title>
        <v-card-text class="pt-0">
            <v-container fluid grid-list-xs>
                <v-layout row wrap ref="form">
                    <v-flex xs12 sm6>
                        <v-menu v-if="!femexfut"
                            lazy
                            :close-on-content-click="true"
                            v-model="showDatePicker"
                            transition="scale-transition"
                            offset-y
                            full-width
                            :nudge-right="40"
                            max-width="290px"
                            min-width="290px"
                            class="green--text"
                            >
                            <v-text-field
                                slot="activator"
                                label="Fecha de inicio de juego"
                                v-model="data.date"
                                prepend-icon="event"
                                readonly
                                light
                                color="green"
                                :rules="rules.required"
                                ref="date"
                            ></v-text-field>
                            <v-date-picker
                                light
                                class="green--text"
                                v-model="data.date"
                                scrollable
                                actions
                                locale="es-MX">
                                <template slot-scope="{ save, cancel }">
                                <v-card-actions>
                                    <v-spacer></v-spacer>
                                    <v-btn flat color="primary" @click="cancel">Cancel</v-btn>
                                    <v-btn flat color="primary" @click="save">OK</v-btn>
                                </v-card-actions>
                                </template>
                            </v-date-picker>
                        </v-menu>
                        <v-menu v-if="femexfut"
                            lazy
                            :close-on-content-click="true"
                            v-model="showDatePicker"
                            transition="scale-transition"
                            offset-y
                            full-width
                            :nudge-right="40"
                            max-width="290px"
                            min-width="290px"
                            class="green--text"
                            >
                            <v-text-field
                                slot="activator"
                                label="Fecha de inicio de juego"
                                v-model="data.date"
                                prepend-icon="event"
                                light
                                color="green"
                                ref="date"
                            ></v-text-field>
                            <v-date-picker
                                light
                                class="green--text"
                                v-model="data.date"
                                scrollable
                                actions
                                locale="es-MX">
                                <template slot-scope="{ save, cancel }">
                                <v-card-actions>
                                    <v-spacer></v-spacer>
                                    <v-btn flat color="primary" @click="cancel">Cancel</v-btn>
                                    <v-btn flat color="primary" @click="save">OK</v-btn>
                                </v-card-actions>
                                </template>
                            </v-date-picker>
                        </v-menu>
                    </v-flex>
                    <v-flex xs12 sm6>
                        <v-menu v-if="!femexfut"
                            lazy
                            :close-on-content-click="false"
                            v-model="showTimePicker"
                            transition="scale-transition"
                            offset-y
                            full-width
                            :nudge-right="40"
                            max-width="290px"
                            min-width="290px"
                            class="green--text"
                            >
                            <v-text-field
                                slot="activator"
                                label="Hora de inicio"
                                prepend-icon="event"
                                v-model="data.time"
                                readonly
                                light
                                color="green"
                                ref="time"
                            ></v-text-field>
                            <v-time-picker
                                light
                                v-model="data.time"
                                class="green--text"
                                scrollable
                                actions
                                locale="es-MX"
                                format="24hr">
                                <template slot-scope="{ save, cancel }">
                                <v-card-actions>
                                    <v-spacer></v-spacer>
                                    <v-btn flat color="primary" @click="cancel">Cancel</v-btn>
                                    <v-btn flat color="primary" @click="save">OK</v-btn>
                                </v-card-actions>
                                </template>
                            </v-time-picker>
                        </v-menu>
                        <v-menu v-if="femexfut"
                            lazy
                            :close-on-content-click="false"
                            v-model="showTimePicker"
                            transition="scale-transition"
                            offset-y
                            full-width
                            :nudge-right="40"
                            max-width="290px"
                            min-width="290px"
                            class="green--text"
                            >
                            <v-text-field
                                slot="activator"
                                label="Hora de inicio"
                                prepend-icon="event"
                                v-model="data.time"
                                light
                                color="green"
                                ref="time"
                            ></v-text-field>
                            <v-time-picker
                                light
                                v-model="data.time"
                                class="green--text"
                                scrollable
                                actions
                                locale="es-MX"
                                format="24hr">
                                <template slot-scope="{ save, cancel }">
                                <v-card-actions>
                                    <v-spacer></v-spacer>
                                    <v-btn flat color="primary" @click="cancel">Cancel</v-btn>
                                    <v-btn flat color="primary" @click="save">OK</v-btn>
                                </v-card-actions>
                                </template>
                            </v-time-picker>
                        </v-menu>
                    </v-flex>
                    <v-flex xs12 sm6>
                        <v-text-field
                            label="Duración (min)"
                            v-model="data.duration"
                            light
                            type="number"
                            color="green"
                            :rules="rules.gameTime"
                            ref="gameTime"
                        ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm6>
                        <v-select v-if="!femexfut"
                            :items="fields"
                            label="Cancha"
                            :item-text = "'name'"
                            bottom
                            light
                            color="green"
                            :rules="rules.required"
                            v-model="data.court"
                            ref="court"
                        ></v-select>
                        <v-select v-if="femexfut"
                            :items="fields"
                            label="Cancha"
                            :item-text = "'name'"
                            bottom
                            light
                            color="green"
                            v-model="data.court"
                            ref="court"
                        ></v-select>
                    </v-flex>
                </v-layout>
            </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red darken-1" flat @click.native="cancel()">No</v-btn>
          <v-btn color="green darken-1" flat @click.native="confirm(true)">Si</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
</template>

<script>
import Moment from 'moment';
import Match from '@/models/match'
import { extendMoment } from 'moment-range';
import { mapActions, mapGetters } from 'vuex'
import Utils from '@/utils/utils'

const moment = extendMoment(Moment);

export default {
    name: 'NewGameModal',
    props: {
        dialog: { required: true, default: false },
        match: {required: true},
        fields: {required: true, default:[]},
        gameForEdit: { required: true },
        allmatches: {required:true, default:[]},
        tournament: {required:true},
        femexfut: {required: true}
    },
    data() {
        return {
            tryToSave:false,
            error:null,
            hasErrors: false,
            showDatePicker: false,
            showTimePicker: false,
            time: "",
            date: "",
            data: {
                date: '',
                time: '',
                court: null,
                duration: 0
            },
            rules: {
                required: [
                    val => {
                        let res = ((String(val) || '').length > 0 && val != null) || 'Este campo es obligatorio'
                        return res
                    }
                ],
                gameTime: [
                    val => {
                        let res = (String(val) || '').length > 0 || 'Este campo es obligatorio'
                        if(res === true) res = (String(val) > 0 || 'La cantidad debe ser mayor a 0')
                        return res
                    }
                ]
            }
        }
    },
    watch: {
        currentFieldIsAvailable(val){
          if(this.dialog && this.tryToSave){
            if(val.tournament_id != this.tournament && val.available == false){
              this.error = "Ya existe otro partido agendado a la misma hora en esa cancha"
            }else{
              this.responseOk()
            }
          }
        },
        currentSetDate(val) {
            if(!femexfut)
                this.data.date = moment(val).format('YYYY-MM-DD')
        },
        /*gameForEdit(val) {
            if(val != null) {
                console.log('Position', val.position)
                this.data = {
                    date: moment(val.game.date).format('YYYY-MM-DD'),
                    time: moment(val.game.date).format('HH:mm'),
                    court: null,
                    gameTime: val.game.duration
                }
            }
        },*/
        match(val){
          if(!val){return}
          this.clearFieldIsAvailable()
          this.error = null
          this.tryToSave = false
          this.data.time = moment(val.date).format('HH:mm')
          this.data.date = moment(val.date).format('YYYY-MM-DD')
          this.data.court = val.court
          this.data.duration = val.duration

        }
    },
    computed: {
      ...mapGetters([
        "currentFieldIsAvailable"
      ]),
        form() {
            return {
                date: this.data.date,
                time: this.data.time,
                court: this.data.court,
                gameTime: this.data.duration,
            }
        }
    },
    methods: {
        ...mapActions([
          'clearFieldIsAvailable',
          'fieldIsAvailable'
        ]),
        confirm(btnPressed) {

            this.tryToSave = true
            this.hasErrors = false
            if(!this.femexfut) {
                Object.keys(this.form).forEach(f => {

                    if(!this.form[f])
                        this.hasErrors = true

                    this.$refs[f].validate(true)
                })
            }

            console.log('errors?', this.hasErrors)
            if(this.hasErrors) return

            if(!this.femexfut && !this.checkDateAvailabilityInlocalData()) return
            var match = new Match()
            match.date = moment(`${this.data.date} ${this.data.time}`).toDate()
            match.duration = this.data.duration
            match.court = this.data.court
            if(!this.femexfut) this.checkDateAvailabilityInServer(match)
            /*let result = this.gameForEdit ? null : this.match
            this.error = ""
            this.$emit('response', result)*/
            if(this.femexfut) this.responseOk()
        },
        checkDateAvailabilityInlocalData(){
          this.error = ""
          for(let i=0;i<this.allmatches.length;i++){
            let matchToCompare = this.allmatches[i]
            if(this.match == matchToCompare) continue;
            if(this.data.court != matchToCompare.court) continue;
            let matchDate = moment(`${this.data.date} ${this.data.time}`)
            let matchToCompareDate = moment(matchToCompare.date)
            if(Utils.overlapsByDurarion(matchDate,matchToCompareDate,this.data.duration,matchToCompare.duration)){
              this.error = "Ya existe otro partido agendado a la misma hora en esa cancha"
              return false
            }
          }
          return true
        },
        responseOk(){
            if(!this.femexfut){
                this.match.date = moment(`${this.data.date} ${this.data.time}`).toDate()
            } else {
                if(this.data.date) {
                    this.match.date = moment(`${this.data.date} ${this.data.time}`).toDate()
                }
            }
          
          this.match.duration = this.data.duration
          this.match.court = this.data.court
          let result = this.gameForEdit ? null : this.match
          this.error = ""
          this.$emit('response', result)
          this.clearFieldIsAvailable()
        },
        checkDateAvailabilityInServer(match){
          this.fieldIsAvailable(match)
        },
        cancel() {
            //this.cleanForm()
            this.error = ""
            this.$emit('cancel', 'newgamemodal')
            this.clearFieldIsAvailable()
        }
    }
}
</script>

<style lang="css" scoped>
</style>



// WEBPACK FOOTER //
// src/components/pages/tournaments/tournament_calendar/NewGameModal.vue